import {useEffect, useMemo, useState} from 'react';
import {getWalletCompatibility, WalletCompatibility} from '../lib/walletDetection';

export type UseWalletType = {
	type: WalletCompatibility;
	isAppleSafari: boolean;
	isAppleOther: boolean;
	isGoogle: boolean;
	isUnknown: boolean;
}

export default function useWalletType(): UseWalletType {
	const [type, setType] = useState<WalletCompatibility>('unknown');

	useEffect(() => {
		// Client-only detection to avoid SSR UA pitfalls
		try {
			const detected = getWalletCompatibility();
			setType(detected);
		} catch (e) {
			setType('unknown');
		}
	}, []);

	return useMemo(() => ({
		type,
		isAppleSafari: type === 'apple-safari',
		isAppleOther: type === 'apple-other',
		isGoogle: type === 'google',
		isUnknown: type === 'unknown',
	}), [type]);
}


